module.exports = __webpack_public_path__ + "static/media/measure_img.b5418f2a.png";